import React from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, ZapIcon, StarIcon, BookOpenIcon, VideoIcon, PaletteIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-gradient-to-b from-[#0e0e0e] to-[#0b0b0b] py-20 md:py-32 px-4 border-t border-white/5" data-id="element-198">
      <div className="max-w-5xl mx-auto" data-id="element-199">
        {/* Encabezado */}
        <div className="text-center mb-12 md:mb-20 max-w-3xl mx-auto" data-id="element-200">
          <div className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#e53935] to-[#ef5350] px-4 py-2 rounded-full text-white text-[10px] md:text-sm font-black uppercase tracking-widest mb-6 shadow-lg" data-id="element-201">
            <span className="animate-pulse" data-id="element-202">🔥</span> 60% OFF por tiempo
            limitado
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6" data-id="element-203">
            Accedé hoy con{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c9a24a] to-[#b8913f]" data-id="element-204">
              precio especial
            </span>
          </h2>
          <p className="text-gray-400 text-lg md:text-2xl font-medium max-w-2xl mx-auto" data-id="element-205">
            Elegí el plan que mejor se adapte a vos y empezá a mejorar tus
            cortes hoy mismo.
          </p>
        </div>

        {/* Grid de Precios */}
        <div className="grid grid-cols-2 gap-3 md:gap-6 lg:gap-10 items-start mb-12" data-id="element-206">
          {/* Tarjeta 1: Pack Barbería */}
          <div className="bg-[#141418] rounded-xl md:rounded-2xl border-2 border-[#c9a24a]/40 shadow-[0_0_20px_rgba(201,162,74,0.08)] overflow-hidden flex flex-col h-full relative" data-id="element-207">
            <div className="bg-gradient-to-br from-[#c9a24a]/8 to-transparent border-b border-[#c9a24a]/15 p-4 md:p-8 text-center relative" data-id="element-208">
              <div className="inline-flex items-center gap-1 bg-[#c9a24a]/10 border border-[#c9a24a]/20 rounded-full px-2.5 py-0.5 md:px-3 md:py-1 mb-3 md:mb-4" data-id="element-209">
                <span className="text-[#c9a24a] text-[8px] md:text-xs font-black uppercase tracking-widest" data-id="element-210">
                  ✂️ Ideal para arrancar
                </span>
              </div>
              <h3 className="text-base md:text-2xl font-black text-white mb-1 md:mb-2" data-id="element-211">
                Pack Barbería
              </h3>
              <p className="text-[#c9a24a]/70 text-[10px] md:text-sm font-semibold mb-4 md:mb-6" data-id="element-212">
                Formación Completa en Barbería
              </p>

              <div className="mb-1" data-id="element-213">
                <span className="text-sm md:text-xl text-gray-500 line-through font-bold" data-id="element-214">
                  $49.990
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-215">
                <span className="text-3xl md:text-5xl font-black text-white" data-id="element-216">
                  $19.990
                </span>
                <span className="text-xs md:text-xl text-gray-400 font-bold" data-id="element-217">
                  ARS
                </span>
              </div>
              <p className="text-[9px] md:text-xs text-[#c9a24a]/60 font-bold" data-id="element-218">
                Ahorrás $30.000
              </p>
            </div>

            <div className="p-4 md:p-8 space-y-2.5 md:space-y-3 flex-grow" data-id="element-219">
              <p className="text-[10px] md:text-sm text-[#c9a24a] font-black tracking-widest uppercase mb-3 md:mb-5" data-id="element-220">
                Todo esto es tuyo:
              </p>
              {['Manual Método Barber Pro completo', 'Videos paso a paso de cada técnica', 'Guía de fades y degradados', 'Acceso inmediato y de por vida'].map(text => <div key={text} className="flex items-start gap-2 md:gap-3 text-gray-300" data-id="element-221">
                  <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-[#c9a24a] flex-shrink-0 mt-0.5" data-id="element-222" />
                  <span className="text-xs md:text-base font-semibold leading-tight" data-id="element-223">
                    {text}
                  </span>
                </div>)}

              <div className="bg-[#c9a24a]/8 border border-[#c9a24a]/15 rounded-lg p-2.5 md:p-3 mt-2" data-id="element-224">
                <p className="text-[9px] md:text-xs text-[#c9a24a]/80 font-bold text-center leading-snug" data-id="element-225">
                  💪 Todo lo que necesitás para empezar a cortar como
                  profesional
                </p>
              </div>
            </div>

            <div className="p-4 md:p-8 pt-0 mt-auto" data-id="element-226">
              <a href="https://checkout.tuvidasimple.shop/cart/44818129059942:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-[#c9a24a] to-[#b8913f] hover:from-[#b8913f] hover:to-[#a6802e] text-white font-black text-xs md:text-lg py-3 md:py-4 rounded-lg md:rounded-xl text-center transition-all shadow-lg uppercase" data-id="element-227">
                EMPEZAR AHORA
              </a>
            </div>
          </div>

          {/* Tarjeta 2: Pack Completo (Más Elegido) */}
          <div className="bg-[#141418] rounded-xl md:rounded-2xl border-2 border-[#c9a24a] shadow-[0_0_30px_rgba(201,162,74,0.15)] overflow-hidden flex flex-col h-full relative" data-id="element-228">
            {/* Cinta de urgencia - solo desktop */}
            <div className="hidden md:block absolute top-7 -right-14 w-56 bg-gradient-to-r from-[#e53935] to-[#ef5350] text-white text-[10px] md:text-xs font-black uppercase tracking-widest py-1.5 text-center rotate-45 shadow-lg z-20" data-id="element-229">
              Cupos limitados
            </div>

            <div className="bg-gradient-to-r from-[#c9a24a] to-[#b8913f] py-1.5 md:py-2 text-center" data-id="element-230">
              <p className="text-white text-[10px] md:text-sm font-black tracking-widest uppercase flex items-center justify-center gap-1 md:gap-2 animate-pulse" data-id="element-231">
                <StarIcon className="w-3 h-3 md:w-4 md:h-4 fill-white" data-id="element-232" /> MÁS
                ELEGIDO
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#e53935]/10 to-[#ff7043]/5 border-b border-[#e53935]/20 p-4 md:p-8 text-center relative" data-id="element-233">
              <h3 className="text-base md:text-2xl font-black text-white mb-1 md:mb-2" data-id="element-234">
                Pack Completo
              </h3>
              <p className="text-gray-400 text-[10px] md:text-sm font-semibold mb-4 md:mb-6" data-id="element-235">
                Barbería + Colorimetría
              </p>

              <div className="mb-1" data-id="element-236">
                <span className="text-sm md:text-xl text-gray-500 line-through font-bold" data-id="element-237">
                  $76.980
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-238">
                <span className="text-3xl md:text-6xl font-black text-white" data-id="element-239">
                  $26.990
                </span>
                <span className="text-xs md:text-2xl text-gray-400 font-bold" data-id="element-240">
                  ARS
                </span>
              </div>
            </div>

            <div className="p-4 md:p-8 space-y-2.5 md:space-y-3 flex-grow" data-id="element-241">
              {/* Pack Barbería incluido */}
              <p className="text-[10px] md:text-xs text-[#c9a24a] font-black tracking-widest uppercase mb-1 md:mb-2" data-id="element-242">
                ✅ Todo el Pack Barbería:
              </p>
              {['Manual Método Barber Pro', 'Videos paso a paso', 'Acceso inmediato'].map(text => <div key={text} className="flex items-start gap-2 md:gap-3 text-gray-300" data-id="element-243">
                  <CheckIcon className="w-3.5 h-3.5 md:w-5 md:h-5 text-[#c9a24a] flex-shrink-0 mt-0.5" data-id="element-244" />
                  <span className="text-[10px] md:text-base font-semibold leading-tight" data-id="element-245">
                    {text}
                  </span>
                </div>)}

              <div className="w-full h-px bg-white/10 my-2 md:my-4" data-id="element-246"></div>

              {/* Colorimetría incluida */}
              <p className="text-[10px] md:text-xs text-[#ef5350] font-black tracking-widest uppercase mb-1 md:mb-2" data-id="element-247">
                🎨 + Formación completa en Colorimetría:
              </p>

              <div className="flex items-start gap-2 md:gap-3 text-white bg-[#ef5350]/10 p-2.5 md:p-4 rounded-lg md:rounded-xl border border-[#ef5350]/20" data-id="element-248">
                <BookOpenIcon className="w-4 h-4 md:w-5 md:h-5 text-[#ef5350] flex-shrink-0 mt-0.5" data-id="element-249" />
                <div data-id="element-250">
                  <span className="block text-[10px] md:text-sm font-bold leading-tight" data-id="element-251">
                    Manual completo de Colorimetría
                  </span>
                  <span className="block text-[9px] md:text-xs text-gray-400 font-medium" data-id="element-252">
                    Ebook profesional de 60 páginas (PDF)
                  </span>
                </div>
              </div>

              <div className="flex items-start gap-2 md:gap-3 text-white bg-[#ef5350]/10 p-2.5 md:p-4 rounded-lg md:rounded-xl border border-[#ef5350]/20" data-id="element-253">
                <VideoIcon className="w-4 h-4 md:w-5 md:h-5 text-[#ef5350] flex-shrink-0 mt-0.5" data-id="element-254" />
                <div data-id="element-255">
                  <span className="block text-[10px] md:text-sm font-bold leading-tight" data-id="element-256">
                    Videos de Colorimetría
                  </span>
                  <span className="block text-[9px] md:text-xs text-gray-400 font-medium" data-id="element-257">
                    Técnicas y aplicaciones prácticas en video
                  </span>
                </div>
              </div>

              <div className="flex items-start gap-2 md:gap-3 text-white bg-[#c9a24a]/10 p-2.5 md:p-4 rounded-lg md:rounded-xl border border-[#c9a24a]/20 mt-2" data-id="element-258">
                <ZapIcon className="w-4 h-4 md:w-5 md:h-5 text-[#c9a24a] flex-shrink-0 mt-0.5" data-id="element-259" />
                <div data-id="element-260">
                  <span className="block text-[10px] md:text-sm font-black leading-tight" data-id="element-261">
                    Valorado en $26.990 — incluido gratis
                  </span>
                </div>
              </div>
            </div>

            <div className="p-4 md:p-8 pt-0 mt-auto" data-id="element-262">
              <a href="https://checkout.tuvidasimple.shop/cart/44818150719590:1" target="_blank" rel="noopener noreferrer" className="cta-primary block w-full text-white font-black text-xs md:text-xl py-3 md:py-5 rounded-lg md:rounded-xl text-center shadow-xl uppercase tracking-wide" data-id="element-263">
                EMPEZAR AHORA
              </a>
            </div>
          </div>
        </div>

        {/* Elementos de confianza inferiores */}
        <div className="max-w-2xl mx-auto" data-id="element-264">
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-gray-500 text-[10px] md:text-sm mb-6 md:mb-10 font-medium" data-id="element-265">
            <div className="flex items-center gap-1.5" data-id="element-266">
              <CreditCardIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-267" />
              <span data-id="element-268">Mercado Pago</span>
            </div>
            <span className="hidden md:inline text-gray-700" data-id="element-269">|</span>
            <div className="flex items-center gap-1.5" data-id="element-270">
              <ShieldCheckIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-271" />
              <span data-id="element-272">Compra 100% segura</span>
            </div>
            <span className="hidden md:inline text-gray-700" data-id="element-273">|</span>
            <div className="flex items-center gap-1.5" data-id="element-274">
              <ZapIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-275" />
              <span data-id="element-276">Acceso inmediato</span>
            </div>
          </div>

          {/* Soporte WhatsApp */}
          <a href="https://wa.link/w7hdgn" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 bg-[#25D366]/10 border border-[#25D366]/30 hover:border-[#25D366] rounded-xl px-4 md:px-6 py-3 md:py-4 transition-all mb-6 md:mb-8 group" data-id="element-277">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 md:w-6 md:h-6 text-[#25D366] flex-shrink-0" data-id="element-278">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-279" />
            </svg>
            <span className="text-[#25D366] text-xs md:text-base font-bold group-hover:text-[#1ebe5d] transition-colors" data-id="element-280">
              ¿Dudas con el pago? Escribinos por WhatsApp
            </span>
          </a>

          {/* Disclaimer producto digital */}
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 text-center" data-id="element-281">
            <p className="text-gray-400 text-[10px] md:text-xs leading-relaxed" data-id="element-282">
              <strong className="text-gray-300" data-id="element-283">Producto digital:</strong> El
              acceso se envía automáticamente por email luego del pago. No se
              envían productos físicos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}